import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const RoutePresetsSection = styled.div`
  padding: ${({ theme }) => theme.spacing.xl};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  background: ${({ theme }) => theme.colors.backgroundLila};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  width: 100%;
`;

export const AddButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;
